import { PermissionRepository } from "../../repositories/PermissionRepository";

/**
 * Update Role Permission Use Case
 * Updates a role permission (admin only)
 */
export class UpdateRolePermissionUseCase {
  constructor(private repository: PermissionRepository) {}

  async execute(
    id: number,
    data: {
      module_code: string;
      action_code: string;
      is_granted: number;
    }
  ): Promise<void> {
    if (!id || id <= 0) {
      throw new Error("Invalid permission ID");
    }

    if (!data.module_code || data.module_code.trim() === "") {
      throw new Error("Module code is required");
    }

    if (!data.action_code || data.action_code.trim() === "") {
      throw new Error("Action code is required");
    }

    if (data.is_granted !== 0 && data.is_granted !== 1) {
      throw new Error("is_granted must be 0 or 1");
    }

    return await this.repository.updateRolePermission(id, data);
  }
}
